import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private isDarkMode: BehaviorSubject<boolean>;
  isDarkMode$: Observable<boolean>;

  constructor(private storageService: StorageService) {
    const savedTheme = this.storageService.getUserTheme();
    this.isDarkMode = new BehaviorSubject<boolean>(savedTheme === 'dark');
    this.isDarkMode$ = this.isDarkMode.asObservable();
    this.isDarkMode$.subscribe((darkMode) => {
      this.storageService.setUserTheme(darkMode ? 'dark' : 'light');
    });
  }

  toggleDarkMode(): void {
    this.isDarkMode.next(!this.isDarkMode.value);
  }

  setTheme(theme: string): void {
    this.isDarkMode.next(theme === 'dark');
  }
}
